import axios, { type AxiosError } from 'axios'

// Create axios instance
export const apiClient = axios.create({
  baseURL: '/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Extract error message from response
    let message = 'An error occurred'

    if (error.response) {
      const data = error.response.data as any

      // First try: Check for our custom error format
      if (data?.error?.message) {
        message = data.error.message
      }
      // Second: Handle FastAPI's detail field (can be string or object)
      else if (data?.detail) {
        if (typeof data.detail === 'string') {
          message = data.detail
        } else if (typeof data.detail === 'object' && data.detail.error?.message) {
          // FastAPI wrapped our custom error response in detail
          message = data.detail.error.message
        } else {
          // detail is an object but doesn't have expected structure
          message = JSON.stringify(data.detail)
        }
      }
      // Fallback: Use axios message or generic
      else if (error.message) {
        message = error.message
      }
    } else if (error.request) {
      message = 'Network error. Please check your connection.'
    }

    // Return enhanced error with message
    return Promise.reject({ ...error, message })
  }
)

export default apiClient
